import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import TagManager from 'react-gtm-module';
import _ from 'lodash';

import getSearchables from '../../redux/actions/searchables';
import mag from './search-icon.svg';
import search from './product-search';
import Spinner from '../Spinner';

const Wrapper = styled.div`
  align-items: center;
  border-bottom: solid 2px #979797;
  display: flex;
  height: 85px;
  margin-bottom: 40px;
  padding: 0 10px;
  width: 100%;
`;

const SearchIcon = styled.img`
  max-width: 25px;
`;

const Input = styled.input`
  border: none;
  color: #b5b5b5;
  flex-grow: 1;
  font-family: FuturaStd;
  font-size: 23px;
  font-weight: 300;
  letter-spacing: 0.2px;
  margin-left: 20px;
  outline: none;
`;

const Mobile = styled.div`
  align-items: center;
  border-bottom: 1px solid #4a4a4a;
  display: flex;
  flex-shrink: 0;
  height: 48px;
  margin-top: 20px;
  padding-left: 10px;
  width: 100%;
`;

const SearchButton = styled.img`
  max-width: 20px;
`;

const SearchBox = styled.input`
  border: none;
  flex-grow: 1;
  height: 36px;
  margin-left: 10px;
  outline: none;
`;

class SearchBar extends React.Component {
  static defaultProps = {
    searchables: undefined,
    copy: {},
  };

  static propTypes = {
    copy: PropTypes.shape(),
    getSearchables: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired,
    searchables: PropTypes.arrayOf(PropTypes.shape()),
    setResult: PropTypes.func.isRequired,
    screenSize: PropTypes.number.isRequired,
  };

  state = {
    text: '',
    gettingTags: false,
  };

  handleChange = e => {
    const { setResult } = this.props;
    const text = e.target.value;
    if (text.length >= 3) {
      this.search(text);
    } else {
      setResult(undefined);
    }
    this.setState({ text });
  };

  handleKeyUp = e => {
    const { text } = this.state;
    if (e.keyCode === 13 && text.length > 0) {
      this.search(text);
    }
  };

  search = async () => {
    const { gettingTags } = this.state;
    const { getSearchables, locale, searchables } = this.props;

    if (!gettingTags) {
      if (searchables.length === 0) {
        this.setState({ gettingTags: true });
        await getSearchables(locale);
        this.setState({ gettingTags: false });
      }
      this.continueSearch();
    }
  };

  continueSearch = () => {
    const { text } = this.state;
    const { searchables, setResult } = this.props;
    const result = search(searchables, text);
    setResult(result);

    this.debounceDataLayer(window.location.pathname);
  };

  debounceDataLayer = _.debounce(pathname => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'productsearch',
        searchkw: this.state.text,
        pagepath: pathname,
      },
    });
  }, 3000);

  render() {
    const { copy, screenSize } = this.props;
    const { gettingTags } = this.state;

    if (screenSize < 2)
      return (
        // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
        <Mobile>
          {gettingTags ? <Spinner show w="20px" h="20px" c="black" /> : <SearchButton src={mag} />}
          <SearchBox placeholder={copy.products_search_sp} onChange={this.handleChange} onKeyUp={this.handleKeyUp} />
        </Mobile>
      );

    return (
      // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
      <Wrapper>
        {gettingTags ? <Spinner show w="25px" h="25px" c="black" /> : <SearchIcon src={mag} />}
        <Input placeholder={copy.products_search_pc} onChange={this.handleChange} onKeyUp={this.handleKeyUp} />
      </Wrapper>
    );
  }
}

const mapState = state => ({
  copy: state.siteOptions.siteCopyGeneral,
  locale: state.locale,
  searchables: state.searchables,
  screenSize: state.screenSize,
});

const mapDispatch = dispatch => ({
  getSearchables: locale => dispatch(getSearchables(locale)),
});

export default connect(mapState, mapDispatch)(SearchBar);



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/SearchBar.js